import { BranchType, WorkshopService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const workshopAvailabilitiesLabourQueryKey = 'WorkshopAvailabilitiesLabourQueryKey';

export type WorkshopAvailabilitiesLabourInput = {
  from?: string;
  to?: string;
  branch?: BranchType;
};

const fetchWorkshopAvailabilitiesLabourQuery = async (input?: WorkshopAvailabilitiesLabourInput) => {
  const data = await WorkshopService.getWorkshopAvailabilitiesLabour(input?.from, input?.to, input?.branch);
  return data;
};

export const useWorkshopAvailabilitiesLabourQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input?: WorkshopAvailabilitiesLabourInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WorkshopService.getWorkshopAvailabilitiesLabour>>,
      QueryError,
      Awaited<ReturnType<typeof WorkshopService.getWorkshopAvailabilitiesLabour>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [workshopAvailabilitiesLabourQueryKey, ...(queryKey ?? []), input],
    () => fetchWorkshopAvailabilitiesLabourQuery(input),
    options
  );
